import { render } from "./import-inner.vue?vue&type=template&id=4fe33404&scoped=true"
import script from "./import-inner.vue?vue&type=script&lang=js"
export * from "./import-inner.vue?vue&type=script&lang=js"

import "./import-inner.vue?vue&type=style&index=0&id=4fe33404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe33404"]])

export default __exports__